/**
 * @generated SignedSource<<6d17c1e7bd4d2485e8811a47d61cc0d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProfileIconButtonProfileQuery$variables = Record<PropertyKey, never>;
export type ProfileIconButtonProfileQuery$data = {
  readonly me: {
    readonly fullName: string;
    readonly hubLink: string;
    readonly id: string;
  };
};
export type ProfileIconButtonProfileQuery = {
  response: ProfileIconButtonProfileQuery$data;
  variables: ProfileIconButtonProfileQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Me",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fullName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hubLink",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileIconButtonProfileQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfileIconButtonProfileQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "d5ebc73f7b60e09874215194fd4cb141",
    "id": null,
    "metadata": {},
    "name": "ProfileIconButtonProfileQuery",
    "operationKind": "query",
    "text": "query ProfileIconButtonProfileQuery {\n  me {\n    id\n    fullName\n    hubLink\n  }\n}\n"
  }
};
})();

(node as any).hash = "b5e840a9a0fac792a6c5ca4bed7f65a5";

export default node;
